<div class="flex flex-row justify-start items-center content-center">
  <lib-cdw-checkbox
    data-testid="search-grid-header-select"
    [checked]="!!(checked$ | async)"
    [indeterminate]="!!(indeterminate$ | async)"
    (click)="clickMultiSelectHeaderCheckbox($event)"
  ></lib-cdw-checkbox>
</div>
